import React from "react"
import Paper from "@material-ui/core/Paper";
import {AppState} from "../../store";
import {connect} from "react-redux";
import {UserState} from "../../store/user/types";
import Welcome from "../welcome/Welcome";
import {withTranslation, WithTranslation} from "react-i18next";
import {compose} from "redux";
import eutrChinese from "../../common/assets/A_GD_Holz_Merkblatt_Lieferanten_CHI_v1.1.pdf";
import eutrEnglish from "../../common/assets/A_GD_Holz_Merkblatt_Lieferanten_ENG_v1.1.pdf";

type HomeProps = WithTranslation & {
    user: UserState;
}

class Home extends React.Component<HomeProps, {}> {

    componentDidMount(): void {
        document.title = this.props.t('home.doctitle')
    }

    render() {
        const t = this.props.t;
        if (!this.props.user.isLoggedIn) {
            return (
                <div>
                    <h3> {t('home.introduction.header')} </h3>
                    <Paper style={{padding: "10px", margin: "25px"}}>
                        <strong> {t('home.introduction.list_header')} </strong>
                        <ul>
                            <li> {t('home.introduction.reach_item')} </li>
                            <li> 
                                {t('home.introduction.eutr_item1') + ' '}
                                <a href={eutrEnglish} target="_blank">{t('home.introduction.here')}</a>
                                {t('home.introduction.eutr_item2') + ' '}
                                <a href={eutrChinese} target="_blank">{t('home.introduction.here')}</a>
                                {t('home.introduction.eutr_item3')}
                            </li>
                            <li> {t('home.introduction.profile_item')} </li>
                            <li> {t('home.introduction.svhclist_item')} </li>
                            <li> {t('home.introduction.bannedsubstances_item')} </li>
                        </ul>
                    </Paper>
                </div>
            )
        } else {
            return (
                <Welcome t={t} />
            )
        }
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default compose(
    withTranslation('common'),
    connect(mapStateToProps)
)(Home) as any;